import ClasImpl from '@/serviceImpl/ClasImpl';
import {getCredentialsOrThrow} from '@/domain/useCases/getCredentialsOrThrow';
import {Parcel} from '@/domain/entities/Parcel';

const getParcelByPointOfInterest = async (year?: number, pointOfInterest?: {lng: number, lat: number}): Promise<Parcel | undefined> => {
  const accessToken = getCredentialsOrThrow();

  if(!pointOfInterest || !year) return;

  const {lng, lat} = pointOfInterest;

  try {
    const result = await ClasImpl.getParcelByPointOfInterest(year, `POINT(${lng} ${lat})`, accessToken);

    if(result.length === 0) return undefined;
    if(result.length === 1) return result[0];
    if(result.length !== 1) {
      console.info('There is more than one parcel, the first one has been returned');
      return result[0];
    }

  } catch (error) {
    console.error('Error fetching parcel by Point of interest', error);
    throw error;
  }

};

export default getParcelByPointOfInterest;